/**
 * @generated SignedSource<<a4676c6aee58be2432d3dd26ee84ad32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteTicketInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteTicketMutation$variables = {
  input: DeleteTicketInput;
  connections: ReadonlyArray<string>;
};
export type deleteTicketMutation$data = {
  readonly deleteTicket: {
    readonly clientMutationId: string | null;
    readonly deletedTicketId: string | null;
  } | null;
};
export type deleteTicketMutation = {
  variables: deleteTicketMutation$variables;
  response: deleteTicketMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedTicketId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteTicketMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteTicketPayload",
        "kind": "LinkedField",
        "name": "deleteTicket",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "deleteTicketMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeleteTicketPayload",
        "kind": "LinkedField",
        "name": "deleteTicket",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedTicketId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "751bdf0bcb10b7ac0df69d1b736a776c",
    "id": null,
    "metadata": {},
    "name": "deleteTicketMutation",
    "operationKind": "mutation",
    "text": "mutation deleteTicketMutation(\n  $input: DeleteTicketInput!\n) {\n  deleteTicket(input: $input) {\n    clientMutationId\n    deletedTicketId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f22858b441b046953da33de64e790c73";

export default node;
